import * as React from 'react';
import { classNames } from 'utils/ui/css';

export interface LoaderProps {
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  // by default, the loader will be full screen and in white background
  className = 'h-screen w-screen bg-white',
}) => {
  return (
    <div className={classNames('ex3d-loader flex items-center justify-center', className)}>
      <div className="ex3d-loader-animation size-16 animate-spin rounded-full border-4 border-gray-300"></div>
    </div>
  );
};

export default Loader;
